import React from 'react';
import mail from '../Assets/Images/mail.png'
import logo from '../Assets/Images/logo.png'
import phone from '../Assets/Images/phone.png'
import { Link, NavLink } from 'react-router-dom';
import { Container } from 'react-bootstrap';
function FooterPage() {

    return (
        <div className='container-fluid'>
            <div className='row footer-section'>
                <div className='col'>
                    <Container>
                        <div className='row justify-content-center mb-lg-5 mb-3'>
                            <div className='col-auto'>
                                <img className='w-100' src={logo} />
                            </div>
                        </div>
                        <div className='border-bottom '>
                            <div className='row justify-content-around g-0  pb-4'>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">Our Fruit</NavLink></div>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">About Us</NavLink></div>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">Technology</NavLink></div>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">Tracebility</NavLink></div>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">In Stores</NavLink></div>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">ESG</NavLink></div>
                                <div className='col-12 col-lg-auto text-center mb-2'><NavLink to="/" className=" NavLink">Contact Us</NavLink></div>
                            </div>
                        </div>
                        <div className='row justify-content-center pt-4 pb-4 social-icons '>
                            <div className='col-auto pe-0 pe-lg-2 pe-xl-4'><Link to="/" target='_blank'><img src="../../../server-build/Images/Facebook.png" className='img-fluid' /></Link></div>
                            <div className='col-auto pe-0 pe-lg-2 pe-xl-4'><Link to="/" target='_blank'><img src="../../../server-build/Images/Twitter.png" className='img-fluid'  /></Link></div>
                            <div className='col-auto pe-0 pe-lg-2 pe-xl-4'><Link to="/" target='_blank'><img src="../../../server-build/Images/Instagram.png" className='img-fluid' /></Link></div>
                            <div className='col-auto pe-0 pe-lg-2 pe-xl-4'><Link to="/" target='_blank'><img src="../../../server-build/Images/LinkedIn.png" className='img-fluid' /></Link></div>
                            <div className='col-auto pe-0 pe-lg-2 pe-xl-4'><Link to="/" target='_blank'><img src="../../../server-build/Images/WhatsApp.png" className='img-fluid' /></Link></div>
                            <div className='col-auto pe-0 pe-lg-2 pe-xl-4' ><Link to="/" target='_blank'><img src="../../../server-build/Images/Email.png" className='img-fluid' /></Link></div>
                        </div>
                    </Container>
                    <div className='row  pt-2 pb-2 mt-3 bg-secondary-subtle'>
                        <div className='col'>
                            <p className='small mb-0 text-center fw-bold' style={{ color: '#757575' }}>© COPYRIGHT FRESHCORE PROVISIONS INDIA PVT. LTD. ALL RIGHT RESERVED</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );


}

export default FooterPage; 